// LICENSE_CODE ZON
'use strict';

/*jslint browser:true, es6:true, node:true, react:true*/
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useLocation, useHistory, Redirect } from 'react-router-dom';
import { renderRoutes, matchRoutes } from 'react-router-config';
import cn from 'classnames';
import hopt from 'hola_opt';
import zutil from 'zutil';
import etask from 'zetask';
import zcountry from 'zcountry';
import www_util from 'hola_pub_util';
import { Cms_switcher } from '../../toolip/pub/ui/toolip/cms_switcher';
import { get_aliased_pathname, get_pathname_for_redirect } from '../../hola/pub/lib/use_pathname';
import { Install_popup } from '../../hola/pub/pages/hola.org/install_popup';
import { Cookie_consent } from '../../shared/ui/cookie_consent/cookie_consent.tsx';
import { Content } from './lib/content';
import { use_search } from './ui/use_search.tsx';
import { Provider } from './context.js';
import { Hola_footer } from './ui/footer.tsx';
import { Navbar } from './ui/navbar.js';
import { Settings_context, Settings_provider } from './settings_ctx.tsx';
import { Data_provider } from './data_ctx.tsx';
import { Meta } from './meta.tsx';
import { use_qs } from './lib/use_qs.ts';
import { Client_hints_provider } from './client_hints.tsx';
import { Settlement_ui } from './ui/sa2025/settlement_ui.tsx';
import { Navbar_hola2023 } from './ui/navbar_hola2023.tsx';
import { Br_footer } from './ui/browser/br_footer.tsx';
import { Intercom } from './shared/intercom.tsx';
import { use_previous } from './lib/use_previous';
import { Country_unavailable } from './vpn_config/country_unavailable';
// @todo: remove unused themes
import hola_dark_theme from './css/core/hola_dark_theme.module.less';
import hola_brand_theme from './css/core/hola_brand_theme.module.less';
import hola_2023_theme from './css/core/hola_2023_theme.module.less';
import hola_theme from './css/core/hola_theme.module.less';
import './css/core/bootstrap_polyfill.less';
// @ts-ignore
import { fetch } from '/util/fetch.js';
import be from './be.js';
import { set_be as plus_util_set_be } from './plus_util.js';
import { set_be as login_utils_set_be } from './ui/login/utils';
import { static_resolvers } from './cms_static_resolvers.ts';
plus_util_set_be(be);
login_utils_set_be(be);
var themes = {
  default: hola_theme,
  dark: hola_dark_theme,
  brand: hola_brand_theme,
  hola2023: hola_2023_theme
};
var r_or_call = v => {
  if (typeof v == 'function') return v();
  return v;
};
var location_region_regex = /^\/vpn\/[^/]+\/[^/]+$/;
var location_only_regex = /^\/vpn\/[^/]+$/;
var geo_block_exempt_regex = /^\/(blog|vpn_(config|settings)\d*)(\/|$)/;
export var App = function App(props) {
  var _matched$, _app_settings$meta, _app_settings$meta$pa, _app_settings$meta2, _app_settings$meta2$p, _props$meta_overrides, _app_settings$meta3, _app_settings$meta3$p, _app_settings$meta4, _app_settings$meta4$p, _app_settings$meta5, _props$meta_overrides2, _app_settings$meta6;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    client = _useState2[0],
    set_client = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    cookie_ready = _useState4[0],
    set_cookie_ready = _useState4[1];
  var history = useHistory();
  if (window) {
    // XXX dmitriiz: dirty hack: we have to send it to a lot places in
    // code
    window.react_history = history;
  }
  var _useLocation = useLocation(),
    current_pathname = _useLocation.pathname,
    location_state = _useLocation.state;
  var pathname = get_aliased_pathname(current_pathname);
  var prev_current_pathname = use_previous(current_pathname);
  var is_main_location = current_pathname.includes(':');
  var is_location = pathname.includes('vpn');
  var is_location_region = location_region_regex.test(current_pathname);
  var is_location_default = location_only_regex.test(current_pathname);
  var pn_redirect = get_pathname_for_redirect(location.pathname);
  var navigated = useRef(false);
  var top_portal_ref = useRef();
  var navbar_portal_ref = useRef();
  var footer_portal_ref = useRef();
  var routes = props.route.routes;
  var i18n = props.i18n_instance;
  var matched = matchRoutes(routes, pathname) || [];
  var silent_state = useMemo(() => {
    return {
      path: matched && matched[0] && matched[0].route.path
    };
  }, []);
  var _useState5 = useState({
      edit_mode: false,
      overrides: _objectSpread({}, props.overrides),
      meta: _objectSpread({}, props.meta_overrides),
      resolvers: static_resolvers,
      create_content: (pn, conf) => etask(function* () {
        yield fetch(`/www_cms/create_content?path=${encodeURIComponent(pn)}`, {
          method: 'POST',
          json: true,
          body: {
            override: conf.override,
            meta: conf.meta
          }
        });
      }),
      save_overrides: (pn, conf, just_state = undefined) => {
        set_app_settings(app_s => _objectSpread(_objectSpread({}, app_s), {}, {
          overrides: _objectSpread(_objectSpread({}, app_s.overrides), {}, {
            [pn]: conf
          })
        }));
        if (conf.loading || conf.error || just_state) return;
        fetch(`/www_cms/save_overrides?path=${encodeURIComponent(pn)}`, {
          method: 'POST',
          json: true,
          body: {
            override: conf
          }
        });
      },
      save_meta: (pn, conf, just_state = undefined) => {
        set_app_settings(app_s => _objectSpread(_objectSpread({}, app_s), {}, {
          meta: _objectSpread(_objectSpread({}, app_s.meta), {}, {
            [pn]: conf
          })
        }));
        if (conf.loading || conf.error || just_state) return;
        fetch(`/www_cms/save_meta?path=${encodeURIComponent(pn)}`, {
          method: 'POST',
          json: true,
          body: {
            meta: conf
          }
        });
      }
    }),
    _useState6 = _slicedToArray(_useState5, 2),
    app_settings = _useState6[0],
    set_app_settings = _useState6[1];
  useEffect(() => {
    if (app_settings.overrides[pathname] && prev_current_pathname && current_pathname === prev_current_pathname) {
      return;
    }
    app_settings.save_overrides(pathname, {
      loading: true
    }, true);
    etask(function* () {
      var lng = props.i18n_instance.language;
      var overrides = yield fetch(`/www_cms/get_overrides?path=${encodeURIComponent(pathname)}&lng=${lng}&reqp=${encodeURIComponent(current_pathname)}`);
      if (overrides && overrides.status == 'ok') {
        var _overrides$translatio;
        props.i18n_instance.addResourceBundle(lng, 'translation', ((_overrides$translatio = overrides.translations[lng]) === null || _overrides$translatio === void 0 ? void 0 : _overrides$translatio.translation) || {});
        app_settings.save_overrides(pathname, overrides.overrides, true);
        app_settings.save_meta(pathname, overrides.meta, true);
      } else app_settings.save_overrides(pathname, {
        error: true
      }, true);
    });
  }, [pathname, current_pathname, prev_current_pathname, app_settings]);
  useMemo(() => {
    hopt.user_currency = zcountry.currency_white_list(hopt.user_currency);
    hopt.user_currencies = [hopt.user_currency];
  }, []);
  useEffect(() => {
    // XXX dmitriiz: hotfix for login.js. there is modal window out of
    // context. We need to get rid of that pattern and remove ui from
    // login.js
    window.global_app_themes = themes;
  }, []);
  useEffect(() => {
    var path = matched && matched[0] && matched[0].route.path;
    if (navigated.current && history.action != 'POP') {
      if (silent_state.path != path) window.scrollTo(0, 0);
    } else navigated.current = true;
    silent_state.path = path;
  }, [pathname]);
  useEffect(() => {
    history.block(() => www_util.before_spa());
    if (window.postponed_js) {
      setTimeout(() => {
        window.postponed_js.forEach(js => {
          var s_el = document.createElement('script');
          s_el.src = js;
          s_el.onerror = function () {
            window.handle_fallback(this);
          };
          document.head.appendChild(s_el);
        });
      }, 0);
    }
    set_client(true);
  }, []);
  var search = use_search(props);
  var t_conf = zutil.get(hopt, 'www_hola.translation', {});
  var t_enabled = t_conf.enabled && matched.every(({
    route
  }) => {
    return route.translation && route.translation.enabled && (!t_conf.only || t_conf.only.indexOf(route.path) > -1);
  });
  var r_translation = matched === null || matched === void 0 ? void 0 : (_matched$ = matched[0]) === null || _matched$ === void 0 ? void 0 : _matched$.route.translation;
  var route_props = Object.assign({
    top_portal_ref,
    navbar_portal_ref,
    footer_portal_ref,
    search,
    t_enabled,
    r_translation
  }, props);
  if (route_props.location) route_props.location = _objectSpread(_objectSpread({}, route_props.location), {}, {
    pathname: pathname
  });
  useEffect(() => {
    i18n.changeLanguage(t_enabled ? i18n.language || props.lang : 'en');
  }, [t_enabled]);
  var _useState7 = useState(1),
    _useState8 = _slicedToArray(_useState7, 2),
    reload = _useState8[0],
    set_reload = _useState8[1];
  useEffect(() => {
    if (matched[0].route && !matched[0].route.loaded) {
      matched[0].route.on_load = () => {
        set_reload(r => r + 1);
        matched[0].route.on_load = undefined;
      };
    }
  }, [matched[0].route && matched[0].route.loaded]);
  var headless = matched.every(({
    route
  }) => r_or_call(route.headless)) || (location_state === null || location_state === void 0 ? void 0 : location_state.headless);
  var footless = matched.every(({
    route
  }) => r_or_call(route.footless)) || (location_state === null || location_state === void 0 ? void 0 : location_state.footless);
  if ((app_settings === null || app_settings === void 0 ? void 0 : (_app_settings$meta = app_settings.meta) === null || _app_settings$meta === void 0 ? void 0 : (_app_settings$meta$pa = _app_settings$meta[pathname]) === null || _app_settings$meta$pa === void 0 ? void 0 : _app_settings$meta$pa.headless) !== undefined) headless = app_settings === null || app_settings === void 0 ? void 0 : (_app_settings$meta2 = app_settings.meta) === null || _app_settings$meta2 === void 0 ? void 0 : (_app_settings$meta2$p = _app_settings$meta2[pathname]) === null || _app_settings$meta2$p === void 0 ? void 0 : _app_settings$meta2$p.headless;
  if ((props === null || props === void 0 ? void 0 : (_props$meta_overrides = props.meta_overrides) === null || _props$meta_overrides === void 0 ? void 0 : _props$meta_overrides.headless) !== undefined) headless = props.meta_overrides.headless;
  if ((app_settings === null || app_settings === void 0 ? void 0 : (_app_settings$meta3 = app_settings.meta) === null || _app_settings$meta3 === void 0 ? void 0 : (_app_settings$meta3$p = _app_settings$meta3[pathname]) === null || _app_settings$meta3$p === void 0 ? void 0 : _app_settings$meta3$p.footless) !== undefined) footless = app_settings === null || app_settings === void 0 ? void 0 : (_app_settings$meta4 = app_settings.meta) === null || _app_settings$meta4 === void 0 ? void 0 : (_app_settings$meta4$p = _app_settings$meta4[pathname]) === null || _app_settings$meta4$p === void 0 ? void 0 : _app_settings$meta4$p.footless;
  var br_footer = matched.every(({
    route
  }) => r_or_call(route.br_footer)) || (location_state === null || location_state === void 0 ? void 0 : location_state.br_footer);
  var qs = use_qs();
  var _ref = matched && matched[0] || {},
    route = _ref.route;
  var overridden_meta = ((_app_settings$meta5 = app_settings.meta) === null || _app_settings$meta5 === void 0 ? void 0 : _app_settings$meta5[pathname]) || {};
  var merged_route = _objectSpread(_objectSpread({}, route), overridden_meta);
  var navbar_route = (props === null || props === void 0 ? void 0 : (_props$meta_overrides2 = props.meta_overrides) === null || _props$meta_overrides2 === void 0 ? void 0 : _props$meta_overrides2.headless) !== undefined ? _objectSpread(_objectSpread({}, merged_route), {}, {
    headless: props.meta_overrides.headless
  }) : merged_route;
  var _host = props.host && props.host.replace(/\./g, '_');
  var _page = pathname.slice(1).replace(/\//g, '_') || 'homepage';
  var wrapper_cls = cn(props.host && `host-${_host}`, `page-${_page}`, props.is_portal || qs.no_animation ? 'no-animation' : '', {
    client,
    portal: props.is_portal
  });
  useEffect(() => {
    if (!route.click_tracking) return;
    var host = route.click_host || _host;
    var handle_click = event => {
      var _www_util$get_click_d = www_util.get_click_data(event.target),
        id = _www_util$get_click_d.id,
        info = _www_util$get_click_d.info;
      if (id) {
        var perr_id = `www_click_${host || 'unknown_host'}_${id}`;
        www_util.perr({
          id: perr_id,
          info,
          build: {
            pathname
          }
        });
      }
    };
    document.addEventListener('click', handle_click);
    return () => document.removeEventListener('click', handle_click);
  }, [_page]);
  var is_embed_style = useMemo(() => qs.embed_hola_browser, []);
  useEffect(() => {
    if (window.location.pathname === '/download_vpn_lp') set_cookie_ready(true);
    if (qs.next == '/embed_style_login' || is_embed_style) set_cookie_ready(true);
  }, [qs, is_embed_style]);
  var def_keywords = 'hola vpn for windows, mac, ios, vpn extension ' + 'for browser';
  var geo_blocked = hopt.user_geo_blocked;
  var site_blocked = !!(geo_blocked !== null && geo_blocked !== void 0 && geo_blocked.blocked) && !geo_block_exempt_regex.test(current_pathname);
  var switch_opt = {
    location: _objectSpread({}, props.location)
  };
  switch_opt.location.pathname = pathname;
  if (pn_redirect) return /*#__PURE__*/React.createElement(Redirect, {
    to: pn_redirect
  });
  var toggle_edit_mode = () => etask(function* () {
    var override_pathname = pathname.includes(':') ? current_pathname : pathname;
    if (!is_main_location && !app_settings.overrides[override_pathname]) {
      var _app_settings$meta$pa2;
      yield app_settings.create_content(`/empty${current_pathname}`, {
        override: app_settings.overrides[pathname],
        meta: {
          meta: _objectSpread({
            robots: 'noindex,nofollow'
          }, (_app_settings$meta$pa2 = app_settings.meta[pathname]) === null || _app_settings$meta$pa2 === void 0 ? void 0 : _app_settings$meta$pa2.meta),
          url: current_pathname
        }
      });
      window.location.reload();
      return;
    }
    return set_app_settings(prev => _objectSpread(_objectSpread({}, prev), {}, {
      edit_mode: !prev.edit_mode
    }));
  });
  var toggle_edit_mode_secondary = () => {
    if (app_settings.edit_mode) {
      set_app_settings(prev => _objectSpread(_objectSpread({}, prev), {}, {
        edit_mode: !prev.edit_mode
      }));
      history.goBack();
      return;
    }
    if (is_location_region) {
      history.push('/vpn/:location/:region');
      set_app_settings(prev => _objectSpread(_objectSpread({}, prev), {}, {
        edit_mode: !prev.edit_mode
      }));
      return;
    }
    if (is_location_default) {
      history.push('/vpn/:location');
      set_app_settings(prev => _objectSpread(_objectSpread({}, prev), {}, {
        edit_mode: !prev.edit_mode
      }));
      return;
    }
    set_app_settings(prev => _objectSpread(_objectSpread({}, prev), {}, {
      edit_mode: !prev.edit_mode
    }));
  };
  return /*#__PURE__*/React.createElement(Data_provider, _extends({}, props, {
    route: route
  }), /*#__PURE__*/React.createElement(Provider, _extends({}, props, {
    headless: headless,
    be: be
  }), /*#__PURE__*/React.createElement(Settings_provider, _extends({}, props, {
    location: window.location,
    route: route,
    themes_add: themes,
    app_settings: app_settings,
    set_app_settings: set_app_settings
  }), /*#__PURE__*/React.createElement(Meta, {
    props: props,
    routes: routes,
    matched: matched,
    def_keywords: def_keywords,
    overrided_meta: app_settings === null || app_settings === void 0 ? void 0 : (_app_settings$meta6 = app_settings.meta) === null || _app_settings$meta6 === void 0 ? void 0 : _app_settings$meta6[pathname]
  }, /*#__PURE__*/React.createElement(Client_hints_provider, props, /*#__PURE__*/React.createElement(Settings_context.Consumer, null, value => site_blocked ? /*#__PURE__*/React.createElement("div", {
    id: 'page_content_wrapper',
    className: cn(wrapper_cls, value.theme.root)
  }, /*#__PURE__*/React.createElement(Country_unavailable, {
    product: "hola",
    country: geo_blocked.country
  })) : /*#__PURE__*/React.createElement("div", {
    id: 'page_content_wrapper',
    key: reload,
    className: cn(wrapper_cls, value.theme.root, is_embed_style && 'embed_in_browser')
  }, /*#__PURE__*/React.createElement(Install_popup, null), !is_main_location && /*#__PURE__*/React.createElement(Cms_switcher, {
    caption: !app_settings.edit_mode ? 'Open CMS' : 'Close CMS',
    on_click: toggle_edit_mode
  }), is_location && /*#__PURE__*/React.createElement(Cms_switcher, {
    caption: !app_settings.edit_mode ? 'Open CMS (:location)' : 'Close CMS (:location)',
    on_click: toggle_edit_mode_secondary,
    secondary: true
  }), /*#__PURE__*/React.createElement(Content, {
    just_meta: true,
    edit_mode: !!qs.edit_meta_mode
  }), /*#__PURE__*/React.createElement(Intercom, {
    with_intercom: props.with_intercom,
    app_id: 'taj8ybxt',
    need_plus: true
  }), ['hola2023', 'default', 'toolip'].includes(value.theme_name) ? /*#__PURE__*/React.createElement(Navbar_hola2023, _extends({}, props, {
    route: navbar_route,
    ref: {
      top_portal_ref,
      navbar_portal_ref
    }
  })) : /*#__PURE__*/React.createElement(Navbar, _extends({
    ref: {
      top_portal_ref,
      navbar_portal_ref
    },
    search: search,
    t_enabled: t_enabled,
    r_translation: r_translation
  }, props, {
    route: navbar_route
  })), renderRoutes(routes, route_props, switch_opt), !cookie_ready && !props.cookie_value ? /*#__PURE__*/React.createElement(Cookie_consent, {
    on_apply: () => {
      set_cookie_ready(true);
    }
  }) : null, !footless && !br_footer && /*#__PURE__*/React.createElement(Hola_footer, {
    user_country: props.user_country,
    ref: footer_portal_ref,
    host: props.host,
    t_enabled: t_enabled,
    r_translation: r_translation,
    route_opt: merged_route
  }), br_footer && /*#__PURE__*/React.createElement(Br_footer, null), /*#__PURE__*/React.createElement(Settlement_ui, {
    top_portal_ref: top_portal_ref
  }))))))));
};